import { useViewVehicleContext } from 'pages/Admin/ViewVehicle/context/ViewVehicleContext';
import styled from 'styled-components';
import { Interior } from './Interior';
import { Exterior } from './Exterior';
import { Mechanical } from './Mechanical';

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  min-height: 300px;
  border-radius: 8px;
  display: flex;

  gap: 8px;
  background: #f9f9f9;
`;

const SectionsWrapper = styled.div`
  display: flex;
  padding: 16px;
  gap: 8px;
  width: 100%;
  overflow-x: scroll;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const SectionLayout = () => {
  return (
    <Wrapper>
      <SectionController />
    </Wrapper>
  );
};

const sectionToComponent: Record<string, () => JSX.Element> = {
  interior: Interior,
  exterior: Exterior,
  mechanical: Mechanical
};

const SectionController = () => {
  const { activeSection, setActiveSection } = useViewVehicleContext();

  const SectionComponent = sectionToComponent[activeSection];
  if (!SectionComponent) return null;

  return (
    <SectionsWrapper>
      <SectionComponent />
    </SectionsWrapper>
  );
};
